import { Grid } from "@mui/material";
import { Labeled, TextField } from "react-admin";

const fields = [
  { source: "journal", label: "Списание", md: 8 },
  { source: "issn", label: "ISSN", md: 4 },
  { source: "volume", label: "Том", md: 4 },
  { source: "issue", label: "Брой", md: 4 },
  { source: "pages", label: "Страници", md: 4 },
  { source: "publisher", label: "Издател", md: 12 },
];

const BibliographySection = () => (
  <Grid
    container
    spacing={2}
  >
    {fields.map(({ source, label, md }) => (
      <Grid
        key={source}
        item
        xs={12}
        md={md}
      >
        <Labeled label={label}>
          <TextField
            source={source}
            emptyText="-"
          />
        </Labeled>
      </Grid>
    ))}
  </Grid>
);

export default BibliographySection;
